module.exports = __webpack_public_path__ + "img/i_m.88470ac7.jpg";